<template>
	<div>
        <form action="./resources/contact-form.php" method="POST" class="contact-form" id="contactForm" novalidate @submit.prevent="ValidateBeforeSubmit">
            <div class="contact-form__block">
                <div class="contact-form__group">
                    <div class="contact-form__input-wrapper">
                        <input v-model="name" v-validate="'required'" type="text" name="name" id="name" class="contact-form__input" autofocus placeholder="ex.Ionescu Adrian">
                        <span class="contact-form__error">{{ errors.first('name') }}</span>
                    </div>
                </div>
                <div class="contact-form__group">
                    <div class="contact-form__input-wrapper">
                        <input v-model="company" v-validate="'required' "type="text" name="company" id="company" class="contact-form__input" placeholder="Nume companie optional">
                    </div>
                    <span class="contact-form__error">{{ errors.first('company') }}</span>
                </div>
                <div class="contact-form__group">
                    <div class="contact-form__input-wrapper">
                        <input v-model="email" v-validate="'required|email'" type="email" name="email" id="email" class="contact-form__input" placeholder="email">
                    </div>
                    <span class="contact-form__error">{{ errors.first('email') }}</span>
                </div>
                <div class="contact-form__group">
                    <div class="contact-form__input-wrapper">
                        <input v-model="phone" type="tel" v-validate="'required|numeric'" name="phone" id="phone" class="contact-form__input"placeholder="numar de telefon optional">
                        <span class="contact-form__error">{{ errors.first('phone') }}</span>
                    </div>
                </div>
                <div class="contact-form__group">
                    <textarea v-model="message" v-validate="'required'" class="contact-form__textarea" name="message" cols="40" rows="10" id="message" placeholder="Mesajul trebuie sa contina minim 20 caractere"></textarea>
                    <span class="contact-form__error">{{ errors.first('message') }}</span>
                </div>
            </div>

            <!-- /.c-form__block -->
            <div class="contact-form__block">
                <div class="button-wrapper text-align--right">
                    <button class="button button--medium button--tertiary button--ghost" aria-label="trimite" type="submit" id="submitBtn">{{ btnText}}</button>
                </div>
            </div>
            <!-- /.c-form__block -->

            <div class="contact-form__copy">
                <p>* {{ infoLegal }} </p>
            </div>
            <!-- /.c-form__block -->
        </form>
        <!-- /# contactForm -->
        <contact-modal v-if="showModal" @close="showModal = false" v-on:keydown.esc="showModal = false"></contact-modal>
	</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import ro from 'vee-validate/dist/locale/ro';

/* eslint-disable */
window.Event = new Vue();
	export default {
		name: 'contact-form',
		data: () => ({
			name: '',
			email: '',
			company: '',
			message: '',
			phone: '',
            showModal: false,
            locale: 'ro',
            infoLegal: 'Informatiile furnizate de dumneavoastra au caracter confidential si nu vor fi utilizate in alte scopuri.',
            btnText: 'Trimite formularul',
		}),
		methods: {
			ValidateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if(result) {
						this.onSubmit();
					} else {
                        console.log('eroare validare campuri');
                    }
				});
			},
			onSubmit() {
				const formData = {
					name: this.name,
					company: this.company,
					email: this.email,
					phone: this.phone,
					message: this.message
				};
				const headers = { 'Access-Control-Allow-Origin:': '*' };
				axios.post('./resources/contact-form.php', formData, headers)
					.then((response) => {
						console.log(response.data.message);
                        if(response.data.message === 'message sent') {
                            this.displayModal();
                            this.resetForm();
                        }
					})
					.catch((error) => {
						console.log(error.response.data);
					});
			},
            displayModal() {
                setTimeout(() => {
                    this.showModal = true;
                }, 1000);
            },
            resetForm() {
                this.name = null;
                this.company = null;
                this.email = null;
                this.phone = null;
                this.message = null;
                this.$nextTick(() => { this.$validator.reset(); });
            }
		},
        created() {
            this.$validator.localize('ro', {
                messages: ro.messages,
                attributes: {
                  "name": "nume",
                  "email": "email",
                  "company": "companie",
                  "phone": "telefon",
                  "message" : "mesaj"
                }
            });
            this.$validator.localize('ro');
        },
       mounted() {
            this.locale = document.documentElement.lang;
            this.$validator.localize(this.locale);
            if(this.locale === 'en') {
                this.infoLegal = 'The information provided by you is confidential and will not be used for other purposes.';
                this.btnText = "Send message";
            }
        }
	};
</script>


// WEBPACK FOOTER //
// src/js/vue/components/contact-form.vue